<template>
  <div class="page-not-found-comp">
    <img class="image" src="./images/img_page_not_found@2x.png" :width="$px(156)" :height="$px(156)" alt="" />
    <p class="text">{{ text }}</p>
  </div>
</template>

<script setup lang="ts">
import { usePage } from './useBase'

withDefaults(defineProps<{ text?: string }>(), { text: '抱歉，您访问的页面不存在' })

usePage()
</script>

<style lang="less">
.page-not-found-comp {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100vh;

  > p.text {
    margin: 12px 0 0 0;
    font-size: 14px;
    font-weight: 600;
    color: #000;
  }
}
</style>
